import { Feature } from "@/lib/models";
import { httpClient } from "@/lib/http-client";
import type { AxiosProgressEvent } from "axios";
import { axiosWithAuth } from "@/lib/AxiosClient";

export interface AttachmentDetails {
  id: string
  filename: string
  entityId: string
  url: string
  size: number
  uploadDate: string
  type: AttachmentType
  originalFilename: string
  dateTaken: string | null
}

export enum AttachmentType {
  None,
  Main
}

export interface NewFeatureRequest extends Feature {
  siteId: string
}

export class AttachmentService {
  private static readonly BASE_PATH = "/api/attachments"
  private static instance = axiosWithAuth;

  static async getByEntityId(entityId: string): Promise<AttachmentDetails[]> {
    return httpClient.get<AttachmentDetails[]>(`${this.BASE_PATH}/${entityId}`)
  }
  
  static async getOldestByEntityIds(entityIds: string[]): Promise<AttachmentDetails[]> {
    return httpClient.post<AttachmentDetails[]>(`${this.BASE_PATH}/main`, { entityIds: entityIds})
  }

  static async deleteAttachment(featureId: string, attachmentId: string): Promise<void> {
    return httpClient.delete<void>(`${this.BASE_PATH}/${featureId}/${attachmentId}`)
  }

  static async uploadAttachment(entityId: string, file: any): Promise<AttachmentDetails[]> {
    return httpClient.upload<AttachmentDetails[]>(`${this.BASE_PATH}/${entityId}`, file)
  }

  static delete(attachmentId: string): Promise<void> {
    return httpClient.delete<void>(`${this.BASE_PATH}/${attachmentId}`)
  }
  
  static async uploadMainImage(entityId: string, file: any): Promise<AttachmentDetails> {
    return httpClient.upload<AttachmentDetails>(`${this.BASE_PATH}/${entityId}/image`, file)
  }

  static async upload(entityId: string, formData: FormData, onUploadProgress: (progressEvent: AxiosProgressEvent) => void): Promise<AttachmentDetails[]> {
    const response = await this.instance.post<AttachmentDetails[]>(`${this.BASE_PATH}/${entityId}`, formData, {
      onUploadProgress: onUploadProgress,
      // headers: {
      //   'Content-Type': 'multipart/form-data'
      // }
    });
    return response.data;
  }
}
